export const FullDealEntryPointBannerTexts = {
  title: 'Первый займ без процентов',
  badgeTitle: 'ЕСТЬ АКТИВНАЯ ЗАЯВКА',
  badgeTitleWithTime: `ПОЛУЧИТЕ ДЕНЬГИ В {time}`,
} as const;
